// LoginForm.jsx
import React, { useState } from "react";
import { Box, TextField, Button, Alert, Typography, Link as MuiLink } from "@mui/material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Login as LoginIcon } from "@mui/icons-material";
import useAuth from "../../hooks/useAuth";

function LoginForm() {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);

	const { login } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();

	// Get redirect path from location state or default to dashboard
	const from = location.state?.from?.pathname || "/";

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!username.trim() || !password) {
			setError("Please enter both username and password");
			return;
		}

		setLoading(true);
		setError(null);

		try {
			await login(username, password);
			navigate(from, { replace: true });
		} catch (err) {
			setError(err.response?.data?.message || "Login failed");
		} finally {
			setLoading(false);
		}
	};

	return (
		<Box component="form" onSubmit={handleSubmit}>
			{error && (
				<Alert severity="error" sx={{ mb: 3 }}>
					{error}
				</Alert>
			)}

			<TextField
				label="Username"
				variant="outlined"
				fullWidth
				margin="normal"
				value={username}
				onChange={(e) => setUsername(e.target.value)}
				required
			/>

			<TextField
				label="Password"
				type="password"
				variant="outlined"
				fullWidth
				margin="normal"
				value={password}
				onChange={(e) => setPassword(e.target.value)}
				required
			/>

			<Button type="submit" variant="contained" fullWidth size="large" disabled={loading} startIcon={<LoginIcon />} sx={{ mt: 3, mb: 2 }}>
				{loading ? "Signing in..." : "Sign In"}
			</Button>

			<Box sx={{ textAlign: "center", mt: 2 }}>
				<Typography variant="body2">
					Don't have an account?{" "}
					<MuiLink component={Link} to="/register">
						Register now
					</MuiLink>
				</Typography>
			</Box>
		</Box>
	);
}

export default LoginForm;
